import React, { useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertKlarnaScript } from "../../utility/klarna";

const KlarnaPlacement = ({ clientId, sellingPrice, enviroment }) => {
  const containerRef = useRef();

  const {
    site: { siteMetadata },
  } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            priceLanguage
          }
        }
      }
    `
  );

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const klarnaPlacement = document.createElement("klarna-placement");
      klarnaPlacement.setAttribute("data-key", "credit-promotion-badge");
      klarnaPlacement.setAttribute("data-locale", siteMetadata.priceLanguage);
      klarnaPlacement.setAttribute("data-purchase-amount", sellingPrice);
      container.appendChild(klarnaPlacement);
      eventuallyInsertKlarnaScript(clientId, enviroment);
      return () => container.removeChild(klarnaPlacement);
    }
  }, [sellingPrice, clientId, enviroment, siteMetadata.priceLanguage]);

  return <div className="mb-3" ref={containerRef}></div>;
};

export default React.memo(KlarnaPlacement);
